var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M19.774 21.52 16.68 26.9H8.575a2.018 2.018 0 0 1-1.75-1.015L.266 14.454a2.019 2.019 0 0 1 0-2.007L2.762 8.1l3.08 5.35 4.642 8.07h9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "m29.993 14.454-6.556 11.432a2.016 2.016 0 0 1-1.75 1.015h-5.01l3.096-5.38 4.646-8.072-4.646-8.07h6.166l4.053 7.068c.359.62.36 1.385.001 2.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M25.94 5.38H10.484l-4.642 8.07-3.08-5.353 4.061-7.082A2.016 2.016 0 0 1 8.573 0h13.115c.723 0 1.39.388 1.75 1.015L25.94 5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m19.774 5.38 4.643 8.07-4.644 8.069h-9.287l-4.644-8.07 4.642-8.07h9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.13 17.485a4.036 4.036 0 1 0 0-8.07 4.036 4.036 0 0 0 0 8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.823 1.181A2.016 2.016 0 0 1 8.573.167h13.115c.723 0 1.39.387 1.75 1.014l2.408 4.2h.096L23.44 1.014A2.016 2.016 0 0 0 21.689 0H8.573c-.723 0-1.391.387-1.75 1.015L2.761 8.097l.048.084 4.013-7Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A237E",
    fillOpacity: 0.2,
    d: "m5.842 13.45 4.642-8.07H25.94l-.096-.168h-15.36l-4.642 8.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.267 12.615 2.495-4.35 3.08 5.352 4.642 8.07h9.193l.098-.169h-9.29L5.841 13.45l-3.08-5.352-2.495 4.348a2.03 2.03 0 0 0-.263 1.089c.013-.324.103-.64.263-.92Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF360C",
    d: "M16.776 26.73H8.574c-.723 0-1.391-.386-1.75-1.014L.266 14.286a2.025 2.025 0 0 1-.263-.92c-.018.38.074.757.263 1.088l6.556 11.433a2.016 2.016 0 0 0 1.75 1.014h8.107l.096-.17Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    d: "m24.513 13.45-4.642-8.07h-.096l4.644 8.07h.094Zm5.48.835-6.556 11.433a2.016 2.016 0 0 1-1.75 1.014h-4.911l-.098.169h5.008a2.02 2.02 0 0 0 1.751-1.015l6.556-11.432c.189-.331.28-.709.263-1.089a2.025 2.025 0 0 1-.263.92Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.94 5.547 4.053 7.067c.16.282.25.597.263.92a2.005 2.005 0 0 0-.263-1.088L25.94 5.379h-6.166l.098.168h6.068Zm-6.166 16.141 4.74-8.238h-.095l-4.645 8.07-3.095 5.38h.097l2.998-5.212Z",
    opacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30.316v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/GCP.32c35bf14647995c4ddbecc73ba95187.svg";
export { ForwardRef as ReactComponent };